<template>
  <div>
    <v-toolbar flat>
      <v-menu v-model="searchBox" offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn width="100%" min-height="45" rounded v-bind="attrs" v-on="on">
            <v-icon>mdi-magnify</v-icon>Search Transmittals...<v-spacer
            ></v-spacer>
          </v-btn>
        </template>
        <v-form @submit.prevent="lookupTransmittals">
          <v-card height="100%" width="100%">
            <v-row no-gutters>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="First Name"
                  v-model="form.firstName"
                  dense
                  outlined
                  class="mx-6 mt-6"
                ></v-text-field
              ></v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Last Name"
                  v-model="form.lastName"
                  dense
                  outlined
                  class="mx-6 mt-6"
                ></v-text-field
              ></v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="OSIS"
                  v-model="form.osis"
                  v-mask="maskOsis"
                  outlined
                  dense
                  class="mx-6 mt-6"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4">
                <v-autocomplete
                  v-model="form.schoolId"
                  :items="schools"
                  :item-text="
                    (item) =>
                      item.dbn
                        ? `${item.schoolName} (${item.dbn})`
                        : item.schoolName
                  "
                  item-value="schoolId"
                  label="School"
                  clearable
                  outlined
                  dense
                  class="mx-6"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4">
                <v-autocomplete
                  v-model="form.programId"
                  :items="rsPrograms"
                  :item-text="(item) => `${item.code} - ${item.name}`"
                  item-value="programId"
                  label="Program"
                  clearable
                  outlined
                  dense
                  class="mx-6"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4">
                <v-autocomplete
                  v-model="form.serviceId"
                  :items="rsServices"
                  :item-text="(item) => `${item.code} - ${item.name}`"
                  item-value="serviceId"
                  label="Service"
                  clearable
                  outlined
                  dense
                  class="mx-6"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="form.statuses"
                  :items="statusOptions"
                  label="Status"
                  multiple
                  clearable
                  outlined
                  dense
                  class="mx-6"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-autocomplete
                  v-model="form.semesterId"
                  label="Semester"
                  :items="semesters"
                  :item-text="
                    (item) =>
                      `${item.semesterCode} - ${item.semesterDescription}`
                  "
                  item-value="semesterId"
                  clearable
                  outlined
                  dense
                  class="mx-6"
                ></v-autocomplete>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" type="submit"
                >Lookup Transmittals</v-btn
              >
              <v-btn small outlined class="mx-6" @click="clear">Clear </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-menu>
    </v-toolbar>
    <transmittals-table
      v-if="showTable"
      :transmittals="transmittals"
      :isProcessed="true"
    ></transmittals-table>
  </div>
</template>

<script>
import TransmittalSearchOptions from "../../objs/TransmittalSearchOptions";
import TransmittalsTable from "./transmittals-table.vue";
import { clearOsisFormat } from "../../utils/format-utils";
import { TransmittalStatus } from "../../objs/TransmittalStatus";
export default {
  components: { TransmittalsTable },
  data() {
    return {
      form: new TransmittalSearchOptions(),
      maskOsis: "###-###-###",
      searchBox: false,
      statusOptions: Object.values(TransmittalStatus),
    };
  },
  mounted() {
    this.$store.dispatch("transmittalsModule/clearTransmittals");
    this.form.semesterId = this.currentSemester?.semesterId;
  },
  computed: {
    schools() {
      return this.$store.state.optionsModule.schools;
    },
    rsPrograms() {
      return this.$store.getters["optionsModule/getRelatedServicesPrograms"];
    },
    rsServices() {
      return this.$store.getters["optionsModule/getRSServices"];
    },
    semesters() {
      return this.$store.state.optionsModule.semesters;
    },
    currentSemester() {
      return this.$store.getters["optionsModule/getCurrentSemester"];
    },
    showTable() {
      return this.$store.state.transmittalsModule.transmittals.length > 0;
    },
    transmittals() {
      return this.$store.state.transmittalsModule.transmittals || [];
    },
  },
  methods: {
    clear() {
      this.form = new TransmittalSearchOptions();
      this.form.semesterId = this.currentSemester?.semesterId;
    },
    async lookupTransmittals() {
      this.searchBox = false;
      this.$store.commit("uxModule/setShowLoader", true);
      this.form.osis = clearOsisFormat(this.form.osis);
      let success = await this.$store.dispatch(
        "transmittalsModule/searchTransmittals",
        {
          ...this.form,
        }
      );

      this.$store.commit("uxModule/setShowLoader", false);
      if (success) {
        if (!this.$store.state.transmittalsModule.transmittals.length > 0) {
          this.$store.commit(
            "uxModule/setSnackbarMsg",
            "No transmittals found"
          );
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Error Retrieving Transmittals"
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.clear();
    },
  },
};
</script>
